import { useState } from "react";
import moment from "moment";
import { useForm } from "react-hook-form";
import { useRecoilValue } from "recoil";
import { get, isEmpty, map, orderBy, size } from "lodash";
import { useTranslation } from "react-i18next";
import {
  checkArrayLength,
  // defaultAttachmentImage,
  IsJsonString,
} from "src/utils";
import {
  INCOMING_FORMAT,
  KENDO_DATE_FORMAT,
  DEFAULT_DAYSTOCOMPLETE,
} from "src/constants";
import { Auth } from "aws-amplify";
import { loggedInUserState } from "Recoil/LoggedInUserDetail/atom";
// import { useFormattedData } from "Hooks/useFormattedData";
import {
  CompanyDetails,
  metaDataDetails,
} from "Recoil/LoggedInUserDetail/selector";
import { displayRating, trimLower } from "src/utils/general";
import { useHistory, useParams } from "react-router";
import CloudIcon from "Assets/images/upload-cloud-orange.svg";
import PlusIcon from "Assets/images/plus-orange.svg";
import { useRoleAndPermission } from "Hooks/permissions/useRoleAndPermission";

export const useTargetConstants = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams();
  const { handlePendingUserPermission } = useRoleAndPermission();
  const useTemplateState = history?.location?.pathname;
  const _loggedInUser = useRecoilValue(loggedInUserState);
  const { skills: skillMetaData } = useRecoilValue(metaDataDetails);
  const companyDetail = useRecoilValue(CompanyDetails);
  const { performancerating } = useRecoilValue(metaDataDetails);
  const targetFormStepper = [
    {
      label: t("target.stepper.unsplash"),
      wrapper: "coverPhoto",
      offset: -140,
      customIcon: (
        <span className="step-icon step-banner-icon">
          <img
            src={CloudIcon}
            alt="cover photo"
            className="step-cloud-icon custom-icon"
          />
        </span>
      ),
    },
    {
      label: t("target.stepper.details"),
      wrapper: "details",
      offset: -140,
      customIcon: <span className="step-count count-1">1</span>,
    },
    {
      label: t("target.stepper.assignPeople"),
      wrapper: "assignPeople",
      offset: -140,
      customIcon: <span className="step-count count-2">2</span>,
    },
    {
      label: t("target.stepper.objectives"),
      wrapper: "objectives",
      offset: -140,
      customIcon: (
        <span className="step-count count-3">
          {useTemplateState === "/target/create" ||
          useTemplateState === `/target/edit/${id}`
            ? "3"
            : "2"}
        </span>
      ),
    },
    // {
    //   label: t("target.stepper.advancedOptions"),
    //   wrapper: "advancedOptions",
    //   offset: -200,
    // customIcon: <span className="step-count count-4">4</span>
    // },
    {
      label: t("target.stepper.checkins"),
      wrapper: "checkins",
      offset: -200,
      customIcon: (
        <span className="step-icon step-checkin-icon">
          <img
            src={PlusIcon}
            alt="add checkin"
            className="step-plus-icon custom-icon"
          />
        </span>
      ),
    },
  ];

  const [activeStep, setActiveStep] = useState(0);

  const onScrollSpyUpdate = (wrapper) => {
    const currentStep = targetFormStepper.find(
      (item) => item.wrapper === wrapper
    );
    setActiveStep(currentStep);
  };

  const checkinMapping = (checkin, isTemplate = false) => {
    let description = "<p></p>";
    let attachments = [];
    let questionOptions = [];

    if (isTemplate) {
      // description = checkin?.description;
      attachments = checkin?.linkCheckin?.link
        ? [checkin?.linkCheckin?.link]
        : [checkin?.multimediaCheckin?.s3Link];
      questionOptions = checkin?.surveyCheckin?.surveycheckin.map((item) => {
        return {
          type: item.questionType,
          question: item.question,
          answer: item.answer,
          options: item.options,
          disableAddOption: false,
        };
      });
    }

    return {
      current: {
        id: checkin?.id,
        isTemplate,
        checkinId: checkin?.id,
        checkInStatus: checkin?.checkInStatus,
        type: checkin?.checkInType,
        title: "",
        targetMode: "",
        checkinMode: "",
        checkinModal: false,
      },
      details: {
        createFrequency: {
          launchDate: moment(checkin?.startDate).format(INCOMING_FORMAT),
          isWeekend: checkin?.isWeekend,
          weekDays: checkin?.weekDays || [],
          frequency: checkin?.frequency,
          frequencyRepeatDays: checkin?.frequencyRepeatDays || 1,
          frequencyRepeatonDate: checkin?.frequencyRepeatonDate,
          frequencyRepeatMonthly: {
            dayofMonth: checkin?.frequencyRepeatMonthly?.dayofMonth,
            dayOfWeekOccurrence:
              checkin?.frequencyRepeatMonthly?.dayOfWeekOccurrence,
            dayOfWeek: checkin?.frequencyRepeatMonthly?.dayOfWeek,
            toggleDaysOfMonth:
              checkin?.frequencyRepeatMonthly?.dayOfWeek === 0
                ? "dayOfWeekOccurrence"
                : "dayofMonth",
          },
        },
        title: checkin?.name,
        launchDate: moment(checkin?.startDate).format(INCOMING_FORMAT),
        launchTime: "",
        dueTime: "",
        templateLaunchDateTime: "", //get(checkin, "templateLaunchDateTime", ""),
        templateEndDateTime: "", // get(checkin, "templateEndDateTime", ""),
        isImmediate: checkin?.isImmediate,
        templateLaunchDay: get(checkin, "templateLaunchDay", 1),
        daysToComplete: get(checkin, "daysToComplete", DEFAULT_DAYSTOCOMPLETE),
        dueDate: get(checkin, "endDate", ""),
        frequency: "None",
        requiredAttachment: false,
        requiredComment: false,
        isWeekend: false,
        frequencyRepeatDays: checkin?.frequencyRepeatDays,
        frequencyRepeatMonthly: {
          dayofMonth: moment(checkin?.startDate).date() || 1,
          dayOfWeekOccurrence: null,
          dayOfWeek: null,
          toggleDaysOfMonth: "dayofMonth",
        },
        //description: get(checkin, "description", "<p></p>"),
        description,
        skills: [],
        isTestSurvey: false,
        isAnonymousResponses: false,
        multimedia: {
          dragLoader: false,
          dragAndDrop: {},
          pasteLink: "",
          attachments,
        },
      },
      assignPeople: {
        searchText: { coachee: "", coach: "" },
        userListData: [], // individual user list
        userGroupData: [], // coachee group list
        coachListData: [], // coach list
        viewerListData: [],
        userListCount: size(checkin?.usersForCheckin?.items),
      },
      questions: {
        addQuestionMode: "",
        createQuestion: {
          type: "None",
          question: "",
          answer: [],
          options: [""],
          disableAddOption: false,
        },
        questionsList: questionOptions,
      },
      viewLink: {},
    };
  };

  const targetFormDefaults = {
    mainLoader: false,
    publishTargetModal: false,
    cancelTargetModal: false,
    unsavedPrompt: true,
    targetId: "",
    isTargetActiveOrOverdue: false,
    targetStatus: "DRAFT",
    currentAction: "TargetInformation",
    isTemplate: false,
    saveToTemplateLibrary: false,
    assignPeople: {
      searchText: { coachee: "", coach: "" },
      userGroupData: [], // coachee group list
      userListData: [], // individual user list
      coachListData: [], // coach list
      markComplete: false,
    },
    coverPhoto: {
      isCoverPhotoChanged: false,
      base64: "",
      imageLoader: false,
      dragLoader: false,
      selectedImage: "",
      image: "",
      modalOpen: false,
    },
    details: {
      targetType: "Job",
      title: "",
      startDate: moment().format("YYYY-MM-DD"),
      endDate: "",
      targetDescription: "<p></p>",
      weightage: "",
      skillsAndStrengths: [],
    },
    objectives: {
      createObjective: {
        name: "",
        isDeleted: false,
        objectiveStatusTrack: true,
        objectiveSequenceNo: 0,
        users: {},
        assignPeople: {
          searchText: { coachee: "", coach: "" },
          userListData: [], // individual user list
        },
        editUser: false,
      },
      objectiveTeamview: false,
      objectiveList: [],
      removedObjectiveList: [],
    },
    advancedOptions: {
      dragLoader: false,
      dragAndDrop: {},
      pasteLink: "",
      attachments: [],
      linkedTargets: {
        searchText: "",
        targetsData: [],
      },
    },
    checkin: {
      searchText: "",
      createCheckin: { ...checkinMapping() },
      checkinList: [],
      addedTemplateList: [],
      selectedTemplate: [],
    },
    autoSave: {
      targetId: "",
      display: {
        type: "warning",
        message: "",
      },
      lastSaved: {},
      loading: false,
      isAutoSavedBeforeSubmit: false,
    },
  };

  const methods = useForm({
    defaultValues: targetFormDefaults,
    mode: "all",
  });

  const editTargetValues = (data) => {
    let isTargetPublished = false;
    if (["OVERDUE", "ACTIVE"].includes(data.targetStatus)) {
      isTargetPublished = true;
    }
    const links = get(data, "targetAttachmentLinks", []) || [];
    const documents =
      get(data, "document", []).map((d) => {
        return { ...d, name: d.fileName };
      }) || [];
    const attachments = [...links, ...documents];

    const linkedTargets = (get(data, "linkTarget", []) || []).map(
      ({ __typename, ...target }) => target
    );

    let selectPhoto = "";
    if (!isEmpty(get(data, "logo.fileName"))) {
      selectPhoto = `${process.env.REACT_APP_CLOUD_FRONT_URL}/${get(
        data,
        "logo.fileName",
        ""
      )}`;
    }

    const skillsAndStrengths = (get(data, "skillsAndStrengths", []) || []).map(
      (item) => {
        return { ...item, isDisabled: true };
      }
    );

    const checkinList = data?.checkin?.items.map((checkin) =>
      checkinMapping(checkin, data?.isTemplate)
    );

    const markComplete = get(data, "completionApprovalRequired", false);

    return {
      mainLoader: false,
      publishTargetModal: false,
      cancelTargetModal: false,
      unsavedPrompt: true,
      saveToTemplateLibrary: false,
      targetId: data.id,
      isTargetActiveOrOverdue: isTargetPublished,
      targetStatus: data.targetStatus,
      currentAction: "TargetInformation",
      assignPeople: {
        searchText: { coachee: "", coach: "" },
        userGroupData: [], // coachee group list
        userListData: [], // individual user list
        coachListData: [], // coach list
        markComplete,
      },
      coverPhoto: {
        base64: "",
        dragLoader: false,
        selectedImage: "",
        image: "",
        modalOpen: false,
        fileDetails: get(data, "logo"),
        selectPhoto,
      },
      details: {
        targetType: data.type,
        title: data.title,
        startDate: data.startDate //get(useTemplateState, "useThisTemplate", false)
          ? moment(data.startDate).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
        endDate: moment(data.dueDate).format("YYYY-MM-DD"),
        targetDescription: data.description,
        weightage: data.weightage,
        skillsAndStrengths,
      },
      objectives: {
        createObjective: {
          name: "",
          isDeleted: false,
          completionRequired: false,
          objectiveSequenceNo: 0,
          objectiveStatusTrack: true,
          canEdit: true,
          isDeletable: true,
          users: {},
        },
        objectiveList: [],
        removedObjectiveList: [],
        objectiveTeamview: data.objectiveTeamview,
      },
      advancedOptions: {
        dragAndDrop: {},
        pasteLink: "",
        attachments,
        linkedTargets: {
          searchText: "",
          targetsData: linkedTargets,
        },
      },
      checkin: {
        createCheckin: { ...checkinMapping() },
        checkinList,
        addedTemplateList: [],
        selectedTemplate: [],
      },
      autoSave: {
        targetId: "",
        display: {
          type: "warning",
          message: "",
        },
        lastSaved: {},
        loading: false,
        isAutoSavedBeforeSubmit: false,
      },
    };
  };

  const fetchObjectiveCount = (data) => {
    return {
      objective: get(data, "targetObjective.items", ""),
      checkin: get(data, "checkin.items", ""),
    };
  };

  const fetchTargetDetails = (data) => {
    const userRole = get(Auth, "user.attributes.custom:role");
    const currentUserId = get(Auth, "user.attributes.custom:userId", "");
    const primaryCoachId = get(data, "primaryCoach.id", "");

    const fetchTargetType =
      (get(companyDetail, "referenceFeature.target", []) || []).length &&
      get(companyDetail, "referenceFeature.target", []).find(
        (res) => res.type === get(data, "type", "")
      );

    let selectPhoto = "";
    if (!isEmpty(get(data, "logo.fileName"))) {
      selectPhoto = `${process.env.REACT_APP_CLOUD_FRONT_URL}/${get(
        data,
        "logo.fileName",
        ""
      )}`;
    }
    const title = get(data, "title", "");
    const type = get(data, "type", "");
    const displayTargetType = get(fetchTargetType, "name", type);
    const dueDate = get(data, "dueDate")
      ? moment(get(data, "dueDate")).format(KENDO_DATE_FORMAT)
      : "";
    const startDate = get(data, "startDate")
      ? moment(get(data, "startDate")).format(KENDO_DATE_FORMAT)
      : "";
    const completionDate = get(
      data,
      "userTargetStatusOfLoginUser.completionDate"
    )
      ? moment(get(data, "userTargetStatusOfLoginUser.completionDate")).format(
          KENDO_DATE_FORMAT
        )
      : "";
    const description = get(data, "description", "");
    const createdBy = get(data, "createdBy");
    const targetStatus =
      data?.userTargetStatusOfLoginUser?.status || get(data, "targetStatus");
    const readAttachment = get(data, "readAttachment");

    const links = get(data, "targetAttachmentLinks", []) || [];
    const documents =
      (data?.document || []).map((d) => {
        return { ...d, name: d.fileName };
      }) || [];
    const attachments = [...links, ...documents];

    let targetUsers = [];
    let coachUser = [];
    let people = [];
    if (checkArrayLength(get(data, "targetUser.items", []))) {
      targetUsers = map(get(data, "targetUser.items", []), "user").map(
        (user) => {
          return { ...user, isCoach: false };
        }
      );
    }

    if (checkArrayLength(get(data, "coachTarget.items", []))) {
      coachUser = map(get(data, "coachTarget.items", []), "coach").reduce(
        (result, item) => {
          if (item.id === primaryCoachId) {
            result.push({ ...item, isPrimaryCoach: true, isCoach: true });
          } else {
            result.push({ ...item, isPrimaryCoach: false, isCoach: true });
          }
          return result;
        },
        []
      );
    }
    people = [...coachUser, ...targetUsers] 
    // handlePendingUserPermission()
    //   ? [...coachUser, ...targetUsers]
    //   : [...coachUser, ...targetUsers].filter(
    //       (res) => res?.status !== "PENDING"
    //     );

    const addSkillsPermission =
      map([...people, createdBy], "id").includes(currentUserId) ||
      userRole === "CompanyAdmin";

    const skillsAndStrengths = (get(data, "skillsAndStrengths", []) || []).map(
      (item) => {
        return { ...item, isDisabled: true };
      }
    );

    const linkTarget = get(data, "linkTarget", []);

    const isTargetCreator =
      primaryCoachId === currentUserId ||
      createdBy?.id === currentUserId ||
      userRole === "CompanyAdmin";

    const targetEditable =
      isTargetCreator &&
      !["COMPLETED", "INCOMPLETED", "ARCHIVED"].includes(targetStatus);

    // Check for targetcreator as coachee
    // const findCreator = people.find((u) => u?.id === createdBy?.id);
    let allUsers = [...people];
    // if (isEmpty(findCreator)) {
    //   allUsers = [...people, { ...createdBy, isCoach: true }];
    // }

    const isLeadReviewer = allUsers.some(
      (u) => u.id === currentUserId && u.isCoach && u.isPrimaryCoach
    );

    const isCoach = allUsers.some(
      (u) => u.id === currentUserId && u.isCoach && !u.isPrimaryCoach
    );

    const isCoachee = allUsers.some(
      (u) => u.id === currentUserId && !u.isCoach && !u.isPrimaryCoach
    );

    let userType = "";
    let roleDisplay = "";

    if (isLeadReviewer) {
      userType = "leadReviewer";
      roleDisplay = "Lead reviewer";
    } else if (isCoach) {
      userType = "coach";
      roleDisplay = "Support reviewer";
    } else if (isCoachee) {
      userType = "coachee";
      roleDisplay = "Self review";
    }

    const userRating = get(data, "userTargetStatusOfLoginUser");
    const userTargetStatus = get(userRating, "status");

    const completionApprovalRequired = get(
      data,
      "completionApprovalRequired",
      false
    );

    let submitTarget = false;
    if (["leadReviewer"].includes(userType)) {
      submitTarget = ["ACTIVE", "OVERDUE"].includes(targetStatus);
    } else if (userType === "coach") {
      submitTarget =
        // !completionApprovalRequired &&
        ["ACTIVE", "OVERDUE"].includes(targetStatus);
    } else if (["coachee"].includes(userType)) {
      submitTarget =
        isEmpty(userTargetStatus) ||
        ["ACTIVE", "OVERDUE"].includes(userTargetStatus);
    }

    const selfRating = !isEmpty(performancerating)
      ? displayRating([...performancerating], get(userRating, "selfRating"))
      : userRating?.selfRating || null;

    const leadRating = !isEmpty(performancerating)
      ? displayRating(
          [...performancerating],
          get(userRating, "leadReviewerRating")
        )
      : userRating?.leadReviewerRating || null;

    return {
      id: get(data, "id"),
      selectPhoto,
      logo: get(data, "logo"),
      title,
      isTemplate: get(data, "isTemplate"),
      type,
      objectiveTeamview: get(data, "objectiveTeamview"),
      targetLevelUserRoleTypeForSRS: data?.targetLevelUserRoleTypeForSRS,
      displayTargetType,
      userType,
      roleDisplay,
      targetStatus,
      dueDate,
      startDate,
      completionDate,
      description,
      createdBy,
      attachments,
      people: orderBy(people, "isPrimaryCoach", "asc"),
      linkTarget,
      skillsAndStrengths,
      targetEditable,
      addSkillsPermission,
      submitTarget,
      userRating,
      selfRating,
      leadRating,
      selfRatingBanner: userRating?.selfRating,
      leadRatingBanner: userRating?.leadReviewerRating,
      completionApprovalRequired,
      allUsers: [
        ...get(data, "coachTarget.items", []),
        ...get(data, "targetUser.items", []),
      ],
      readAttachment,
    };
  };

  const skillsQuestionsMapping = (skills) => {
    return (skills || []).map((item) => {
      if (!checkArrayLength(item.questions)) {
        const filterResult = (skillMetaData || []).find(
          (skill) => trimLower(skill.name) === trimLower(item.name)
        );
        let questions = [];
        if (
          IsJsonString(get(filterResult, "value", "")) &&
          JSON.parse(get(filterResult, "value", '"[]"')).length
        ) {
          questions = JSON.parse(get(filterResult, "value", '"[]"'));
        }
        return { ...item, ...filterResult, questions };
      }
      return { ...item };
    });
  };

  return {
    targetFormDefaults,
    methods,
    activeStep,
    setActiveStep,
    targetFormStepper,
    onScrollSpyUpdate,
    checkinMapping,
    editTargetValues,
    fetchTargetDetails,
    fetchObjectiveCount,
    skillsQuestionsMapping,
  };
};
